import script from "./PrintController.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrintController.vue?vue&type=script&setup=true&lang=ts"

import "./PrintController.vue?vue&type=style&index=0&id=34d16987&lang=scss"

const __exports__ = script;

export default __exports__